export const mergeFlags = <T>(
  defaultFlagValues: { [key: string]: unknown },
  flags: { [key: string]: unknown },
  jsonFlagValues?: string[],
) => {
  const mergedFlags = {
    ...(defaultFlagValues || {}),
    ...flags,
  };

  jsonFlagValues?.forEach((key) => {
    const keyStr = key.toString();
    try {
      mergedFlags[keyStr] = JSON.parse(mergedFlags[keyStr] as string);
    } catch (e) {
      console.error(`Could not parse feature flag value for ${keyStr}!`);
    }
  });

  return mergedFlags as T;
};

export const mergeVariation = <T>(
  defaultFlagValue: T | false,
  flag: { name: string; variation: unknown },
  jsonFlagValues?: string[],
) => {
  const parsedVariation = jsonFlagValues?.find((value) => value === flag.name)
    ? JSON.parse(flag.variation as string)
    : flag.variation;

  return (parsedVariation as T) ?? defaultFlagValue;
};

export const proxyFlags = <T extends { [key: string]: unknown }>(
  defaultFlagValues?: Partial<T>,
) =>
  new Proxy<T>({} as T, {
    get(_target, name) {
      return defaultFlagValues?.[name as string] || false;
    },
  });
